import React from 'react';
import { Link } from 'react-router-dom';
import { useMenuData } from '../hooks/useMenuData';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const HomePage = () => {
  const { menuData, loading, error } = useMenuData();
  const [containerRef, isIntersecting] = useIntersectionObserver();
  
  // Check if device is mobile for reduced animation delays
  const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const animationDelay = isMobile ? 0.05 : 0.1;

  if (loading) {
    return (
      <div className="home-page loading-container" ref={containerRef}>
        <div className="loading-spinner"></div>
        <p>Loading menu...</p>
      </div>
    );
  }

  if (error && !menuData) {
    return (
      <div className="home-page error-container" ref={containerRef}>
        <p>Failed to load menu. Please try again later.</p>
      </div>
    );
  }

  const categories = Object.values(menuData);

  return (
    <div className={`home-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
      <div className="categories-grid">
        {categories.map((category, index) => (
          <Link 
            key={category.id} 
            to={`/category/${category.id}`} 
            className={`category-card ${isIntersecting ? 'fade-in-up-active' : ''}`}
            style={{ animationDelay: `${(index + 1) * animationDelay}s` }}
          >
            <div className="category-title">{category.name}</div>
            {/* <div className="category-description">{category.description}</div> */}
            <div className="category-count">{category.items.length} items</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
